import { SUPPORT_CONTACT } from "@/constants";
import { useWhitelabel } from "@/providers";
import {
  type ResolvedSupportContact,
  resolveSupportContact,
} from "@/utils/resolveSupportContact";

/**
 * Returns the whitelabel-aware support email / phone / hours for the current
 * brand, falling back to the platform `SUPPORT_CONTACT`. Thin wrapper around
 * the pure `resolveSupportContact` (unit-tested separately).
 */
export function useSupportContact(): ResolvedSupportContact {
  const whitelabel = useWhitelabel();
  return resolveSupportContact(whitelabel, SUPPORT_CONTACT);
}
